import type { HelpFile } from '../../types/help'
import { ValueListsTestIds } from '../../../testids/ValueListsTestIds'

export const valueListsHelp: HelpFile = {
  docPage: '/docs/schema/value-lists',
  texts: {
    [ValueListsTestIds.valueLists]: 'Wertelisten definieren geordnete Mengen von Nachschlagewerten, die in Dropdowns und Validierungsregeln verwendet werden.',
    [ValueListsTestIds.btnCreateValueList]: null,
    [ValueListsTestIds.colActive]: 'Inaktive Wertelisten sind in Formular-Auswahlmenüs ausgeblendet und nicht auswählbar.',
    [ValueListsTestIds.colDescription]: null,
    [ValueListsTestIds.colDisplayName]: null,
    [ValueListsTestIds.colName]: null,
    [ValueListsTestIds.inputVlDescription]: null,
    [ValueListsTestIds.inputVlDisplayName]: null,
    [ValueListsTestIds.inputVlName]: 'Interner Bezeichner — wird in API-Referenzen und Ausdrücken verwendet; nach der Erstellung nicht mehr änderbar.',
  },
}
